import api from '@pray/shared/utils/api';

export const deleteFeatureFlag = async (flagId: string) => {
  if (!flagId) throw Error('Flag ID is required');

  const url = `/web/studio/feature-flags/${flagId}`;
  const response = await api.executeDeleteRequest(url);
  return response.data;
};
